import { Observable } from 'rxjs';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PuntosInteresService {

  constructor(private http: HttpClient) { }

  getPuntos() {
    return this.http.get(`${environment.API_SECURITY}/api/puntosinteres`);
  }


  postPinteres(form: any[]): Observable<any>{
      return this.http.post<any>(`${environment.API_SECURITY}/api/puntosinteres`,form);
  }


  deletePunto(id: any){
      return this.http.delete(`${environment.API_SECURITY}/api/puntosinteres/${id}`);
  }

  updatedPunto(id: any, form) {
	return this.http.put<any>(`${environment.API_SECURITY}/api/puntosinteres/${id}`,form);

  }

  getPutoByID(id: any){
      return this.http.get(`${environment.API_SECURITY}/api/puntosinteres/${id}`);
  }
}
